module.exports = __webpack_public_path__ + "img/gilderoys_poster.120f971d.jpg";